// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"676":"3df0d9eb8a221a712c12","908":"c0cc6d50b8f842656e32"}[chunkId] + ".js";
};